const initialState = {
  new2284Form: false,
  epdIrId: null,
  reportingProgram: '',
  reportingProgramId: null,
  paroleAgentOfRecord: '',
  incidentLocation: null,
  incidentDate: null,
  orgAddress: null,
  admitDate: null,
  incidentAddress: null,
  incidentTime: null,
  caseManagerName: null,
  caseManagerTelephone: null,
  caseManagerEmail: null,
  dapo: false,
  dhcs: false,
  drp: false,
  other: false,
  otherDescription: null,
  isContactedFire: false,
  isContactedParamedics: false,
  isContactedPolice: false,
  contactedAgenciesName: null,
  isParoleArrested: false,
  arrestingAgency: null,
  arrestDate: null,
  isNewsMediaCoverage: false,
  newsAgency: null,
  newsRepNameAndPhone: null,
  isLawEnforcementContacted: false,
  lawEnforcementAgency: null,
  incidentDescription: null,
  incidentCreateDate: '',
  incidentCreatedBy: '',
};

export default initialState;
